module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: {
      'action-button': true, 'block': _vm.block, 'medium': _vm.medium
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c9e8e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ActionButton.vue
// module id = 542
// module chunks = 1